export default __webpack_public_path__ + "static/cmo-6e02d10e6f7dbbefeca988007b004c33.png";